import Body from './Body/Body';
import Header from './Header/Header';
import { MODAL_CONTROL_ACTIONS } from 'src/utils/enums/user-store-actions.enum';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    ADD_NEW_USER_MODAL_LABEL_BUTTON_CANCEL,
    ADD_NEW_USER_MODAL_LABEL_BUTTON_CONFIRM,
    ADD_NEW_USER_MODAL_TITLE,
    EDIT_USER_MODAL_CONTENT,
} from 'src/localization/resouceKeys';
import {
    DealerAssociation,
    DealerPermission,
} from 'src/services/models/dealer-management.service';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import './styles.scss';

interface IEditUserProps {
    backClick: Function;
    username: string;
    setErrorNotification: Dispatch<SetStateAction<boolean>>;
    dealerPermissions: Array<DealerPermission>;
    dealerAssociations: Array<DealerAssociation>;
    setIsSuccessDeleted: Dispatch<SetStateAction<boolean>>;
    showOnlyDeleteOption?: boolean;
    isDSMSearch?: boolean;
}

const EditUser: React.FC<IEditUserProps> = ({
    backClick,
    username,
    setErrorNotification,
    dealerPermissions,
    dealerAssociations,
    setIsSuccessDeleted,
    showOnlyDeleteOption = false,
    isDSMSearch = false,
}) => {
    const { i18n, t } = useTranslation();
    const dispatch = useDispatch();
    const [shouldLoadList, setShouldLoadList] = useState<boolean>(false);
    const [isUserActive, setIsUserActive] = useState<boolean>(true);

    const handleActiveModal = () => {
        if (isUserActive) {
            dispatch({
                type: MODAL_CONTROL_ACTIONS.SET_ACTIVE,
                payload: {
                    titleContent: t(ADD_NEW_USER_MODAL_TITLE),
                    bodyContent: t(EDIT_USER_MODAL_CONTENT),
                    cancelBtnLabel: t(ADD_NEW_USER_MODAL_LABEL_BUTTON_CANCEL),
                    confirmBtnLabel: t(ADD_NEW_USER_MODAL_LABEL_BUTTON_CONFIRM),
                    onCancelHandler: cancelhandler,
                    onConfirmHandler: confirmHandler,
                },
            });
        } else {
            dispatch({
                type: MODAL_CONTROL_ACTIONS.SET_INACTIVE,
            });
        }
    };
    useEffect(() => {
        handleActiveModal();
    }, [isUserActive]);

    useEffect(() => {
        i18n.on('languageChanged', handleActiveModal);

        return () => {
            i18n.off('languageChanged', handleActiveModal);
        };
    }, []);

    const headerBackClickHandler = () => {
        if (isUserActive) {
            dispatch({
                type: MODAL_CONTROL_ACTIONS.SET_SHOW,
                payload: {
                    shouldShow: true,
                    onCancelHandler: cancelhandler,
                    onConfirmHandler: confirmHandler,
                },
            });
        } else {
            backClick(false, false);
        }
    };

    const cancelhandler = () => {
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_SHOW,
            payload: { shouldShow: false },
        });
    };

    const confirmHandler = () => {
        dispatch({
            type: MODAL_CONTROL_ACTIONS.SET_INACTIVE,
        });
        backClick(false, shouldLoadList);
    };

    return (
        <div className={'edit-user-container'}>
            <Header backClickHandler={headerBackClickHandler} />
            <Body
                backClickHandler={backClick}
                setErrorNotification={setErrorNotification}
                username={username}
                dealerPermissions={dealerPermissions}
                dealerAssociations={dealerAssociations}
                setShouldLoadList={setShouldLoadList}
                setIsUserActive={setIsUserActive}
                isUserActive={isUserActive}
                setIsSuccessDeleted={setIsSuccessDeleted}
                showOnlyDeleteOption={showOnlyDeleteOption}
                isDSMSearch={isDSMSearch}
            />
        </div>
    );
};

export default EditUser;
